module.exports = __webpack_public_path__ + "media/metronic/_theme/media/misc/bg-1-78ed2040c21a3c1152696fcf378e690d.jpg";